export const companyNameValidation = {
  required: {
    value: true,
    message: 'requiredField',
  },
  minLength: {
    value: 2,
    message: 'mustContainAMinimumNumberOfCharacters',
  },
};

export const addressValidation = {
  required: {
    value: true,
    message: 'requiredField',
  },
  minLength: {
    value: 6,
    message: 'mustContainAMinimumNumberOfCharacters',
  },
};

export const cityValidation = {
  required: {
    value: true,
    message: 'requiredField',
  },
  minLength: {
    value: 2,
    message: 'mustContainAMinimumNumberOfCharacters',
  },
};
